import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EmisorWizardRequest } from '../models/Emisor/EmisorWizardRequest';
import { HttpClient } from '@angular/common/http';
import { Response } from "src/app/shared/models/Response";
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CypressService {
	private REST_API_SERVER = environment.backend_server + "/Cypress";
  constructor(private http: HttpClient) { }

  processManualPayment(success: boolean, amount: number): Observable<Response<boolean>> {
		return this.http.get<Response<boolean>>(this.REST_API_SERVER + "/processManualPayment/" + success + "/" + amount);
	}

}
